<template>
  <div>
    <div class="design">
      <div class="design_info">
        <div class="Product_mat">
          <div class="Product_mat_info">
            <div class="Product_mat_info_cn">专业服务</div>
            <div class="Product_mat_info_en">Professional Services</div>
          </div>
        </div>
        <div>
          <img
            src="../../assets/img/solution/service.webp"
            width="100%"
            alt=""
          />
        </div>
      </div>
      <div class="tab-box">
        <el-tabs
          type="border-card"
          v-model="activeName"
        >
          <el-tab-pane label="标准件库" name="first">
            <div class="design-layout">
              <div class="left">
                <el-button
                  @click="selectOption('option1')"
                  :class="{ active: currentOption === 'option1' }"
                  >电气开关插座</el-button
                >
                <el-button
                  @click="selectOption('option2')"
                  :class="{ active: currentOption === 'option2' }"
                  >电子标准紧固件</el-button
                >
                <el-button
                  @click="selectOption('option3')"
                  :class="{ active: currentOption === 'option3' }"
                  >液压气动</el-button
                >
                <el-button
                  @click="selectOption('option4')"
                  :class="{ active: currentOption === 'option4' }"
                  >轴承</el-button
                >
                <el-button
                  @click="selectOption('option5')"
                  :class="{ active: currentOption === 'option5' }"
                  >涡轮</el-button
                >
                <el-button
                  @click="selectOption('option6')"
                  :class="{ active: currentOption === 'option6' }"
                  >法兰</el-button
                >
                <el-button
                  @click="selectOption('option7')"
                  :class="{ active: currentOption === 'option7' }"
                  >齿轮</el-button
                >
                <el-button
                  @click="selectOption('option8')"
                  :class="{ active: currentOption === 'option8' }"
                  >弹簧</el-button
                >
                <el-button
                  @click="selectOption('option9')"
                  :class="{ active: currentOption === 'option9' }"
                  >刀具</el-button
                >
                <el-button
                  @click="selectOption('option10')"
                  :class="{ active: currentOption === 'option10' }"
                  >机车车辆通用件</el-button
                >
                <el-button
                  @click="selectOption('option11')"
                  :class="{ active: currentOption === 'option11' }"
                  >机床夹具</el-button
                >
                <el-button
                  @click="selectOption('option12')"
                  :class="{ active: currentOption === 'option12' }"
                  >连接件</el-button
                >
                <el-button
                  @click="selectOption('option13')"
                  :class="{ active: currentOption === 'option13' }"
                  >马达</el-button
                >
                <el-button
                  @click="selectOption('option14')"
                  :class="{ active: currentOption === 'option14' }"
                  >工艺标准件</el-button
                >
                <el-button
                  @click="selectOption('option15')"
                  :class="{ active: currentOption === 'option15' }"
                  >六爪机械臂</el-button
                >
                <el-button
                  @click="selectOption('option16')"
                  :class="{ active: currentOption === 'option16' }"
                  >维修工具</el-button
                >
              </div>
              <div class="right">
                <div class="image" v-show="currentOption === 'option1'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListSwitch"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option2'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListFastener"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option3'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of displayedItems"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option4'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListBearing"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option5'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListTurbine"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option6'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListFlange"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option7'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListGear"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option8'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListSpring"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option9'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListCutting"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option10'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListLocomotive"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option11'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListmachineTool"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option12'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListConnector"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option13'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListMotor"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option14'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListProcesscomponent"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option15'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListRobotic"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentOption === 'option16'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListMaintenance"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="精选模型" name="second">
            <div class="design-layout">
              <div class="left">
                <el-button
                  @click="selectValue('value1')"
                  :class="{ active: currentValue === 'value1' }"
                  >装配体</el-button
                >
                <el-button
                  @click="selectValue('value2')"
                  :class="{ active: currentValue === 'value2' }"
                  >高精曲面</el-button
                >
                <el-button
                  @click="selectValue('value3')"
                  :class="{ active: currentValue === 'value3' }"
                  >重用模型</el-button
                >
                <el-button
                  @click="selectValue('value4')"
                  :class="{ active: currentValue === 'value4' }"
                  >高级颜色</el-button
                >
                <el-button
                  @click="selectValue('value5')"
                  :class="{ active: currentValue === 'value5' }"
                  >PMI模型</el-button
                >
                <el-button
                  @click="selectValue('value6')"
                  :class="{ active: currentValue === 'value6' }"
                  >动画模型</el-button
                >
                <el-button
                  @click="selectValue('value7')"
                  :class="{ active: currentValue === 'value7' }"
                  >大装配模型</el-button
                >
                <el-button
                  @click="selectValue('value8')"
                  :class="{ active: currentValue === 'value8' }"
                  >电路板</el-button
                >
              </div>
              <div class="right">
                <div class="image" v-show="currentValue === 'value1'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListAssemble"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentValue === 'value2'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListCurvedSurface"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentValue === 'value3'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListRepeat"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentValue === 'value4'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListColor"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentValue === 'value5'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListPMI"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentValue === 'value6'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListAMI"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentValue === 'value7'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListLarge"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
                <div class="image" v-show="currentValue === 'value8'">
                  <img
                    :src="item.src"
                    class="img-item"
                    alt=""
                    v-for="(item, index) of imgListPCB"
                    :key="item.value"
                    :id="qrTexxt"
                    @mouseenter="enterFun($event)"
                    @mouseleave="leave"
                    @click="linkTo(item, $event)"
                    @contextmenu.prevent.stop="rightClick(item, $event)"
                    :class="{ 'img-item__last': (index + 1) % 4 === 0 }"
                  />
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="行业案例" name="three">
            <div class="case-content">
              <div
                class="case-img"
                v-for="(item, index) of exampleList"
                :key="item.id"
                @click="goTo(item.link)"
              >
                <div class="case-box">
                  <img
                    :src="item.image"
                    class="case-img__item"
                    :class="{ 'case-img__last': (index + 1) % 4 === 0 }"
                  />
                  <div class="text">{{ item.text }}</div>
                  <div class="text" v-show="item.text1">{{ item.text1 }}</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="下载中心" name="four">
            <div class="design-layout">
              <div class="left">
                <el-button
                  @click="selectData('data1')"
                  :class="{ active: currentData === 'data1' }"
                  >电气开关插座</el-button
                >
                <el-button
                  @click="selectData('data2')"
                  :class="{ active: currentData === 'data2' }"
                  >电子标准紧固件</el-button
                >
                <el-button
                  @click="selectData('data3')"
                  :class="{ active: currentData === 'data3' }"
                  >液压气动</el-button
                >
                <el-button
                  @click="selectData('data4')"
                  :class="{ active: currentData === 'data4' }"
                  >轴承</el-button
                >
                <el-button
                  @click="selectData('data5')"
                  :class="{ active: currentData === 'data5' }"
                  >涡轮</el-button
                >
                <el-button
                  @click="selectData('data6')"
                  :class="{ active: currentData === 'data6' }"
                  >法兰</el-button
                >
                <el-button
                  @click="selectData('data7')"
                  :class="{ active: currentData === 'data7' }"
                  >齿轮</el-button
                >
                <el-button
                  @click="selectData('data8')"
                  :class="{ active: currentData === 'data8' }"
                  >弹簧</el-button
                >
                <el-button
                  @click="selectData('data9')"
                  :class="{ active: currentData === 'data9' }"
                  >刀具</el-button
                >
                <el-button
                  @click="selectData('data10')"
                  :class="{ active: currentData === 'data10' }"
                  >机车车辆通用件</el-button
                >
                <el-button
                  @click="selectData('data11')"
                  :class="{ active: currentData === 'data11' }"
                  >机床夹具</el-button
                >
                <el-button
                  @click="selectData('data12')"
                  :class="{ active: currentData === 'data12' }"
                  >连接件</el-button
                >
                <el-button
                  @click="selectData('data13')"
                  :class="{ active: currentData === 'data13' }"
                  >马达</el-button
                >
                <el-button
                  @click="selectData('data14')"
                  :class="{ active: currentData === 'data14' }"
                  >工艺标准件</el-button
                >
                <el-button
                  @click="selectData('data15')"
                  :class="{ active: currentData === 'data15' }"
                  >六爪机械臂</el-button
                >
                <el-button
                  @click="selectData('data16')"
                  :class="{ active: currentData === 'data16' }"
                  >维修工具</el-button
                >
              </div>
              <div class="down-box">
                <div class="content" v-show="currentData === 'data1'">
                  <el-table :data="modifiedSwitchData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data2'">
                  <el-table :data="modifiedFastenerData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data3'">
                  <el-table :data="modifiedHydraulicData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data4'">
                  <el-table :data="modifiedBearingData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data5'">
                  <el-table :data="modifiedTurbineData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data6'">
                  <el-table :data="modifiedFlangeData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data7'">
                  <el-table :data="modifiedGearData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data8'">
                  <el-table :data="modifiedSpringData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data9'">
                  <el-table :data="modifiedCuttingData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data10'">
                  <el-table :data="modifiedLocomotiveData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data11'">
                  <el-table
                    :data="modifiedMachineToolData"
                    style="width: 100%;"
                  >
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data12'">
                  <el-table :data="modifiedConnectorData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data13'">
                  <el-table :data="modifiedMotorData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data14'">
                  <el-table
                    :data="modifiedProcesscomponentData"
                    style="width: 100%"
                  >
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data15'">
                  <el-table :data="modifiedRoboticData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="content" v-show="currentData === 'data16'">
                  <el-table :data="modifiedMaintenanceData" style="width: 100%">
                    <el-table-column label="模型名称">
                      <template slot-scope="scope">
                        <div class="model-content">
                          <span class="iconfont icon-moxing model"></span>
                          <span class="name">{{ scope.row.psth }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="100">
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          style="font-size: 18px; color: #0047FF;"
                          @click.native.prevent="downLoad(scope.row.psth)"
                        >
                          <span class="file-name">下载</span>
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
          <el-tab-pane label="服务说明" name="five">
            <div class="design-service">
              <div class="service-title">服务说明</div>
              <div
                class="service-box"
                v-for="(item, index) in serviceList"
                :key="index"
              >
                <el-button type="primary"> {{ item.title }} </el-button>
                <span> {{ item.content }} </span>
              </div>
            </div>
            <div class="design-contact">
              <div class="contact-title">联系我们</div>
              <div class="contact-box">
                <div class="contact-left">
                  <div class="left_info">
                    <span
                      >留下您的信息，方便我们与您沟通，更好地优化使用体验~</span
                    >
                    <img
                      src="../../assets/img/solution/solution_info.png"
                      alt=""
                    />
                  </div>
                </div>
                <div class="contact-right">
                  <el-form
                    :model="ruleForm"
                    :rules="rules"
                    ref="ruleForm"
                    label-width="100px"
                    class="Solution_info_Text_input"
                  >
                    <el-form-item label="姓名:" prop="name">
                      <el-input v-model="ruleForm.name"></el-input>
                    </el-form-item>

                    <el-form-item label="Email:" prop="email">
                      <el-input v-model="ruleForm.email"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:" prop="tel">
                      <el-input v-model="ruleForm.tel"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称:" prop="cname">
                      <el-input v-model="ruleForm.cname"></el-input>
                    </el-form-item>
                    <el-form-item label="公司地址:" prop="address">
                      <el-input v-model="ruleForm.address"></el-input>
                    </el-form-item>
                    <el-form-item
                      label="您希望我们为你做什么:"
                      prop="do"
                      word-break:
                      break-all
                    >
                      <el-input
                        type="textarea"
                        v-model="ruleForm.do"
                        :rows="3"
                        show-word-limit
                        maxlength="100"
                      ></el-input>
                    </el-form-item>
                    <el-button class="Solution_sub" @click="submitform">
                      提交
                    </el-button>
                  </el-form>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <el-dialog
        title="扫码端查看模型"
        :visible.sync="QRCodeShow"
        @opened="qrCodeCreate"
        width="13%"
      >
        <div id="qrCode">
          <div id="code"></div>
          <canvas id="model-canvas"></canvas>
        </div>
      </el-dialog>
      <div v-if="titleshow" class="message-box">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import axios from "axios";
export default {
  name: "design",
  components: {},
  data() {
    return {
      activeName: "first",
      currentOption: "option1",
      currentValue: "value1",
      currentData: "data1",
      filename: "",
      tableData: [],
      imgListPart: [],
      imgListAssemble: [],
      imgListBearing: [],
      imgListSheetMetal: [],
      imgListPCB: [],
      imgListComponent: [],
      imgListCurvedSurface: [],
      imgListRepeat: [],
      imgListColor: [],
      imgListPMI: [],
      imgListAMI: [],
      imgListGear: [],
      imgListLarge: [],
      imgListMachining: [],
      imgListSwitch: [],
      imgListFastener: [],
      imgListHydraulic: [],
      imgListTurbine: [],
      imgListFlange: [],
      imgListSpring: [],
      imgListCutting: [],
      imgListLocomotive: [],
      imgListmachineTool: [],
      imgListConnector: [],
      imgListMotor: [],
      imgListProcesscomponent: [],
      imgListRobotic: [],
      imgListMaintenance: [],
      modifiedSwitchData: [],
      modifiedFastenerData: [],
      modifiedHydraulicData: [],
      modifiedBearingData: [],
      modifiedTurbineData: [],
      modifiedFlangeData: [],
      modifiedGearData: [],
      modifiedSpringData: [],
      modifiedCuttingData: [],
      modifiedLocomotiveData: [],
      modifiedMachineToolData: [],
      modifiedConnectorData: [],
      modifiedMotorData: [],
      modifiedProcesscomponentData: [],
      modifiedRoboticData: [],
      modifiedMaintenanceData: [],
      exampleList: [
        {
          id: 1,
          link:
            "http://internal.pisx.com:8013/DTViewer/dist/Lite/index.html#../../Model/DamagedHelmet.piz",
          image: require("../../assets/img/eg/DamagedHelmet.png"),
          text: "Battle Damaged Sci-fi Helmet by HDRI Haven"
        },
        {
          id: 2,
          link:
            "http://internal.pisx.com:8013/DTViewer/dist/Lite/index.html#../../Model/BoomBox.piz",
          image: require("../../assets/img/eg/BoomBox.png"),
          text: "BoomBox (PBR) by Microsoft"
        },
        {
          id: 3,
          link:
            "http://internal.pisx.com:8013/DTViewer/dist/Lite/index.html#../../Model/MaterialsVariantsShoe.piz",
          image: require("../../assets/img/eg/Shoe.png"),
          text: "Materials Variants Shoe by Shopify，",
          text1: "Lnc Quarry by HDRI Haven"
        },
        {
          id: 4,
          link: "https://carvisualizer.plus360degrees.com/classics/",
          image: require("../../assets/img/eg/classics.png"),
          text: "CAR VISUALIZER CLASSICS"
        },
        {
          id: 5,
          link:
            "http://internal.pisx.com:8013/DTViewer/dist/Lite/index.html#../../Model/truck.piz",
          image: require("../../assets/img/eg/tuituji.png"),
          text: "three.js - 3MF file with materials"
        },
        {
          id: 6,
          link: "https://neal.fun/design-the-next-iphone/",
          image: require("../../assets/img/eg/design-the-next-iphone.png"),
          text: "Design the Next iPhone by NEAL.FUN"
        },
        {
          id: 7,
          link: "https://exp-gemini.lusion.co/style",
          image: require("../../assets/img/eg/exp-gemini.png"),
          text: "GEMINI"
        },
        {
          id: 8,
          link: "https://carvisualizer.plus360degrees.com/threejs/",
          image: require("../../assets/img/eg/carvisualizer.jpg"),
          text: "CAR VISUALIZER"
        },
        {
          id: 9,
          link: "https://showroom.littleworkshop.fr/",
          image: require("../../assets/img/eg/webvrshowroom.png"),
          text: "WEBVR SHOWROOM, Made by Little Workshop"
        },

        {
          id: 10,
          link: "https://www.lamborghini.com/en-en/3d",
          image: require("../../assets/img/eg/lamborghini.png"),
          text: "lamborghini"
        },
        {
          id: 11,
          link: "https://renaultespace.littleworkshop.fr/",
          image: require("../../assets/img/eg/renaultespace.png"),
          text: "New Renault Espace,",
          text1: "WebGL Visualizer Prototype"
        },
        {
          id: 12,
          link: "https://leap-for-mankind.com/",
          image: require("../../assets/img/eg/leap-for-mankind.png"),
          text: "THE LEAP FOR MANKIND"
        }
      ],
      titleshow: false,
      QRCodeShow: false,
      qrTexxt: "",
      message: "鼠标右键点击查看扫码模型,鼠标左键点击直接查看模型",
      publicPath: process.env.BASE_URL,
      serviceList: [
        {
          title: "CAD模型轻量化服务",
          content:
            "CAD设计软件集成插件，转换PIV格式按套服务，锁定网卡。免费试用转换GLTF，GLTF包含"
        },
        {
          title: "可视化工具服务",
          content:
            "可视化工具分版本购买，简易版免费使用，标准版、专业版、工艺版、企业版按套服务，不限用户"
        },
        {
          title: "批量转换工具服务",
          content: "批量转换工具需配合CAD模型轻量化插件使用，按套服务；"
        },
        // {
        //   title: "三维工艺服务",
        //   content: "三维工艺按模块划分服务；"
        // },
        {
          title: "模型转档服务",
          content:
            "用户免费体验转换5个模型，需转换更多模型需按照模型个数、模型大小收费；"
        },
        {
          title: "定制开发服务",
          content:
            "所有产品均可定制化开发，按需开发评估人天，按人天：3500元/天；"
        }
      ],
      ruleForm: {
        name: "",
        email: "",
        tel: "",
        cname: "",
        address: "",
        do: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (
                /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(
                  value
                ) == false
              ) {
                callback(new Error("邮箱格式错误"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        tel: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            validator: function(rule, value, callback) {
              if (
                /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(
                  value
                ) == false
              ) {
                callback(new Error("请输入合法的手机号"));
              } else {
                callback();
              }
            }
          }
        ],
        cname: [
          {
            message: "请输入公司名称",
            trigger: "blur"
          }
        ],
        address: [
          {
            message: "请输入公司地址",
            trigger: "blur"
          }
        ]
      },
      tab: 1,
      allItems: [], // 存储所有数据
      displayedItems: [], // 当前显示的数据
      pageSize: 20, // 每页显示的项数
      currentPage: 1, // 当前页码
      loading: false, // 是否正在加载更多数据
    };
  },

  created: function() {
    this.$emit("FootItem", true);
  },
  mounted() {
    let router = this.$route.query.view;
    if (router == "center") {
      this.activeName = "four";
    }
    // 加载初始数据
    this.loadMoreData();
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
    //参数：1.路径；2.是否遍历子目录；3.正则表达式
    //零件
    let imgListPart = [];
    const filesPart = require
      .context("/public/img/part", true, /.png|jpg$/)
      .keys();
    filesPart.forEach((e) => {
      imgListPart.push({
        psth: e.slice(1),
        src: require("/public/img/part" + e.slice(1))
      });
    });
    this.imgListPart = imgListPart;

    //装配
    let imgListAssemble = [];
    const filesAssemble = require
      .context("/public/img/assemble", true, /.png|jpg$/)
      .keys();
    filesAssemble.forEach((e) => {
      imgListAssemble.push({
        psth: e.slice(1),
        src: require("/public/img/assemble" + e.slice(1))
      });
    });
    this.imgListAssemble = imgListAssemble;

    // 轴承
    let imgListBearing = [];
    const filesBearing = require
      .context("/public/img/bearing", true, /.png|jpg$/)
      .keys();
    filesBearing.forEach((e) => {
      imgListBearing.push({
        psth: e.slice(1),
        src: require("/public/img/bearing" + e.slice(1))
      });
    });
    this.imgListBearing = imgListBearing;
    let BearingData = this.imgListBearing;
    this.modifiedBearingData = BearingData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 电气开关插座
    let imgListSwitch = [];
    const filesSwitch = require
      .context("/public/img/switch", true, /.png|jpg$/)
      .keys();
    filesSwitch.forEach((e) => {
      imgListSwitch.push({
        psth: e.slice(1),
        src: require("/public/img/switch" + e.slice(1))
      });
    });
    this.imgListSwitch = imgListSwitch;
    let SwitchData = this.imgListSwitch;
    this.modifiedSwitchData = SwitchData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 电子标准紧固件
    let imgListFastener = [];
    const filesFastener = require
      .context("/public/img/fastener", true, /.png|jpg$/)
      .keys();
    filesFastener.forEach((e) => {
      imgListFastener.push({
        psth: e.slice(1),
        src: require("/public/img/fastener" + e.slice(1))
      });
    });
    this.imgListFastener = imgListFastener;
    let FastenerData = this.imgListFastener;
    this.modifiedFastenerData = FastenerData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    //液压气动
    let imgListHydraulic = [];
    const filesHydraulic = require
      .context("/public/img/htdraulic", true, /.png|jpg$/)
      .keys();
    filesHydraulic.forEach((e) => {
      imgListHydraulic.push({
        psth: e.slice(1),
        src: require("/public/img/htdraulic" + e.slice(1))
      });
    });
    this.imgListHydraulic = imgListHydraulic;
    let HydraulicData = this.imgListHydraulic;
    this.modifiedHydraulicData = HydraulicData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 涡轮
    let imgListTurbine = [];
    const filesTurbine = require
      .context("/public/img/turbine", true, /.png|jpg$/)
      .keys();
    filesTurbine.forEach((e) => {
      imgListTurbine.push({
        psth: e.slice(1),
        src: require("/public/img/turbine" + e.slice(1))
      });
    });
    this.imgListTurbine = imgListTurbine;
    let TurbineData = this.imgListTurbine;
    this.modifiedTurbineData = TurbineData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 法兰
    let imgListFlange = [];
    const filesFlange = require
      .context("/public/img/flange", true, /.png|jpg$/)
      .keys();
    filesFlange.forEach((e) => {
      imgListFlange.push({
        psth: e.slice(1),
        src: require("/public/img/flange" + e.slice(1))
      });
    });
    this.imgListFlange = imgListFlange;
    let FlangeData = this.imgListFlange;
    this.modifiedFlangeData = FlangeData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });
    // 弹簧
    let imgListSpring = [];
    const filesSpring = require
      .context("/public/img/spring", true, /.png|jpg$/)
      .keys();
    filesSpring.forEach((e) => {
      imgListSpring.push({
        psth: e.slice(1),
        src: require("/public/img/spring" + e.slice(1))
      });
    });
    this.imgListSpring = imgListSpring;
    let SpringData = this.imgListSpring;
    this.modifiedSpringData = SpringData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 齿轮
    let imgListGear = [];
    const filesGearing = require
      .context("/public/img/gear", true, /.png|jpg$/)
      .keys();
    filesGearing.forEach((e) => {
      imgListGear.push({
        psth: e.slice(1),
        src: require("/public/img/gear" + e.slice(1))
      });
    });
    this.imgListGear = imgListGear;
    let GearData = this.imgListGear;
    this.modifiedGearData = GearData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 刀具
    let imgListCutting = [];
    const filesCutting = require
      .context("/public/img/cutting", true, /.png|jpg$/)
      .keys();
    filesCutting.forEach((e) => {
      imgListCutting.push({
        psth: e.slice(1),
        src: require("/public/img/cutting" + e.slice(1))
      });
    });
    this.imgListCutting = imgListCutting;
    let CuttingData = this.imgListCutting;
    this.modifiedCuttingData = CuttingData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 机车车辆通用件
    let imgListLocomotive = [];
    const filesLocomotive = require
      .context("/public/img/locomotive", true, /.png|jpg$/)
      .keys();
    filesLocomotive.forEach((e) => {
      imgListLocomotive.push({
        psth: e.slice(1),
        src: require("/public/img/locomotive" + e.slice(1))
      });
    });
    this.imgListLocomotive = imgListLocomotive;
    let LocomotiveData = this.imgListLocomotive;
    this.modifiedLocomotiveData = LocomotiveData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 机床夹具
    let imgListmachineTool = [];
    const filesMachinetool = require
      .context("/public/img/machineTool", true, /.png|jpg$/)
      .keys();
    filesMachinetool.forEach((e) => {
      imgListmachineTool.push({
        psth: e.slice(1),
        src: require("/public/img/machineTool" + e.slice(1))
      });
    });
    this.imgListmachineTool = imgListmachineTool;
    let MachineToolData = this.imgListmachineTool;
    this.modifiedMachineToolData = MachineToolData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 连接件
    let imgListConnector = [];
    const filesConnector = require
      .context("/public/img/connector", true, /.png|jpg$/)
      .keys();
    filesConnector.forEach((e) => {
      imgListConnector.push({
        psth: e.slice(1),
        src: require("/public/img/connector" + e.slice(1))
      });
    });
    this.imgListConnector = imgListConnector;
    let ConnectorData = this.imgListConnector;
    this.modifiedConnectorData = ConnectorData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 马达
    let imgListMotor = [];
    const filesMotor = require
      .context("/public/img/motor", true, /.png|jpg$/)
      .keys();
    filesMotor.forEach((e) => {
      imgListMotor.push({
        psth: e.slice(1),
        src: require("/public/img/motor" + e.slice(1))
      });
    });
    this.imgListMotor = imgListMotor;
    let MotorData = this.imgListMotor;
    this.modifiedMotorData = MotorData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 工艺标准件
    let imgListProcesscomponent = [];
    const filesProcesscomponent = require
      .context("/public/img/processComponent", true, /.png|jpg$/)
      .keys();
    filesProcesscomponent.forEach((e) => {
      imgListProcesscomponent.push({
        psth: e.slice(1),
        src: require("/public/img/processComponent" + e.slice(1))
      });
    });
    this.imgListProcesscomponent = imgListProcesscomponent;
    let ProcesscomponentData = this.imgListProcesscomponent;
    this.modifiedProcesscomponentData = ProcesscomponentData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 六爪机械臂
    let imgListRobotic = [];
    const filesRobotic = require
      .context("/public/img/robotic", true, /.png|jpg$/)
      .keys();
    filesRobotic.forEach((e) => {
      imgListRobotic.push({
        psth: e.slice(1),
        src: require("/public/img/robotic" + e.slice(1))
      });
    });
    this.imgListRobotic = imgListRobotic;
    let RoboticData = this.imgListRobotic;
    this.modifiedRoboticData = RoboticData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });

    // 维修保养
    let imgListMaintenance = [];
    const filesMaintenance = require
      .context("/public/img/maintenance", true, /.png|jpg$/)
      .keys();
    filesMaintenance.forEach((e) => {
      imgListMaintenance.push({
        psth: e.slice(1),
        src: require("/public/img/maintenance" + e.slice(1))
      });
    });
    this.imgListMaintenance = imgListMaintenance;
    let MaintenanceData = this.imgListMaintenance;
    this.modifiedMaintenanceData = MaintenanceData.map((item) => {
      item.psth = item.psth.replace(/\.jpg$|\.png$/i, ".piv");
      item.psth = item.psth.slice(1);
      return item;
    });
    //钣金
    let imgListMachining = [];
    const filesMachining = require
      .context("/public/img/machining", true, /.png|jpg$/)
      .keys();
    filesMachining.forEach((e) => {
      imgListMachining.push({
        psth: e.slice(1),
        src: require("/public/img/machining" + e.slice(1))
      });
    });
    this.imgListMachining = imgListMachining;

    //机加工
    let imgListSheetMetal = [];
    const filesSheetMetal = require
      .context("/public/img/sheetMetal", true, /.png|jpg$/)
      .keys();
    filesSheetMetal.forEach((e) => {
      imgListSheetMetal.push({
        psth: e.slice(1),
        src: require("/public/img/sheetMetal" + e.slice(1))
      });
    });
    this.imgListSheetMetal = imgListSheetMetal;

    //电路板
    let imgListPCB = [];
    const filesPCB = require
      .context("/public/img/pcb", true, /.png|jpg$/)
      .keys();
    filesPCB.forEach((e) => {
      imgListPCB.push({
        psth: e.slice(1),
        src: require("/public/img/pcb" + e.slice(1))
      });
    });
    this.imgListPCB = imgListPCB;

    //元器件
    let imgListComponent = [];
    const filesComponent = require
      .context("/public/img/component", true, /.png|jpg$/)
      .keys();
    filesComponent.forEach((e) => {
      imgListComponent.push({
        psth: e.slice(1),
        src: require("/public/img/component" + e.slice(1))
      });
    });
    this.imgListComponent = imgListComponent;

    //曲面
    let imgListCurvedSurface = [];
    const filesCurvedSurface = require
      .context("/public/img/curvedsurface", true, /.png|jpg$/)
      .keys();
    filesCurvedSurface.forEach((e) => {
      imgListCurvedSurface.push({
        psth: e.slice(1),
        src: require("/public/img/curvedsurface" + e.slice(1))
      });
    });
    this.imgListCurvedSurface = imgListCurvedSurface;

    //重用
    let imgListRepeat = [];
    const filesRepeat = require
      .context("/public/img/repeat", true, /.png|jpg$/)
      .keys();
    filesRepeat.forEach((e) => {
      imgListRepeat.push({
        psth: e.slice(1),
        src: require("/public/img/repeat" + e.slice(1))
      });
    });
    this.imgListRepeat = imgListRepeat;

    //颜色
    let imgListColor = [];
    const filesColor = require
      .context("/public/img/color", true, /.png|jpg$/)
      .keys();
    filesColor.forEach((e) => {
      imgListColor.push({
        psth: e.slice(1),
        src: require("/public/img/color" + e.slice(1))
      });
    });
    this.imgListColor = imgListColor;

    //pmi
    let imgListPMI = [];
    const filesPMI = require
      .context("/public/img/pmi", true, /.png|jpg$/)
      .keys();
    filesPMI.forEach((e) => {
      imgListPMI.push({
        psth: e.slice(1),
        src: require("/public/img/pmi" + e.slice(1))
      });
    });
    this.imgListPMI = imgListPMI;

    let imgListAMI = [];
    const filesAMI = require
      .context("/public/img/ami", true, /.webp/)
      .keys();
    filesAMI.forEach((e) => {
      imgListAMI.push({
        psth: e.slice(1),
        src: require("/public/img/ami" + e.slice(1))
      });
    });
    this.imgListAMI = imgListAMI;

    let imgListLarge = [];
    const filesLarge = require
      .context("/public/img/large", true, /.png|jpg$/)
      .keys();
    filesLarge.forEach((e) => {
      imgListLarge.push({
        psth: e.slice(1),
        src: require("/public/img/large" + e.slice(1))
      });
    });
    this.imgListLarge = imgListLarge;
    this.QRCodeShow = false;
  },
  beforeDestroy() {
    // 移除滚动事件监听器，以防止内存泄漏
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    _isMobie() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    handleScroll() {
      // 检查是否滚动到页面底部
      if (
        window.innerHeight + window.scrollY >=
        document.documentElement.offsetHeight
      ) {
        // 防止重复加载
        if (!this.loading) {
          this.loadMoreData();
        }
      }
    },
    loadMoreData() {
      // 模拟异步加载数据
      this.loading = true;
      // 模拟从后端获取数据的操作
      setTimeout(() => {
        // 获取当前页要显示的数据
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        this.allItems = this.allItems.concat(
          this.imgListHydraulic.slice(startIndex, endIndex)
        );
        // 获取当前页要显示的数据
        const newData = this.imgListHydraulic.slice(
          startIndex,
          endIndex
        );
        // 将新数据添加到显示的数据列表中
        this.displayedItems = [...this.displayedItems, ...newData];

        // 增加当前页码
        this.currentPage++;

        // 停止加载状态
        this.loading = false;
      }, 200); // 模拟延迟加载
    },
    submitform() {
      var verify = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
      var verifyTel = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;
      if (
        this.ruleForm.name === "" ||
        this.ruleForm.email === "" ||
        this.ruleForm.tel === ""
      ) {
        this.$message.error({
          message: "信息不能有为空!"
        });
        return;
      }
      if (!verify.test(this.ruleForm.email)) {
        this.$message.error({
          message: "邮箱格式错误,请重新输入 !"
        });
        return;
      }
      if (!verifyTel.test(this.ruleForm.tel)) {
        this.$message.error({
          message: "联系方式格式错误,请重新输入 !"
        });
        return;
      } else {
        this.$axios
          .get("http://internal.pisx.com:8012/api/info", {
            params: {
              infoname: this.ruleForm.name,
              infoemail: this.ruleForm.email,
              infoetel: this.ruleForm.tel,
              infocname: this.ruleForm.cname,
              infoaddress: this.ruleForm.address,
              infodo: this.ruleForm.do
            }
          })
          .then((res) => {
            this.$message({
              message: "提交成功",
              type: "success"
            });
            this.$refs.ruleForm.resetFields();
            this.ruleForm = {
              name: "",
              email: "",
              tel: "",
              cname: "",
              address: "",
              do: ""
            };
          })
          .catch((error) => {
            // console.log(error)
          });
      }
    },
    linkTo(item, e) {
      var imgsrc = item.psth;

      // var editionsrc = imgsrc.substring(1, imgsrc.indexOf('/', imgsrc.indexOf('/') + 1))
      var ifname = imgsrc.substring(0, imgsrc.lastIndexOf("."));

      var qrTexxt =
        "http://internal.pisx.com:8013/TundraViewer/dist/professional/index.html#../../Models/" +
        ifname +
        ".piv";
      this.qrTexxt = qrTexxt;
      window.open(this.qrTexxt, "_blank");
    },
    selectOption(option) {
      this.currentOption = option;
    },
    // loadData() {
    //   if(this.loading) return

    // },
    selectValue(value) {
      this.currentValue = value;
    },
    selectData(data) {
      this.currentData = data;
    },
    rightClick(item, e) {
      var imgsrc = item.psth;
      var ifname = imgsrc.substring(0, imgsrc.lastIndexOf("."));
      var qrTexxt =
        "http://internal.pisx.com:8013/TundraViewer/dist/professional/index.html#../../Models/" +
        ifname +
        ".piv";
      this.qrTexxt = qrTexxt;
      this.QRCodeShow = true;
    },
    goTo(link) {
      window.open(link, "_blank");
    },
    enterFun(event) {
      // console.log('鼠标移入');
      // this.QRCodeShow = true;
      if (this._isMobie()) {
        //判断是手机端/平板端/ 登录入口关闭
        // console.log('ipad')
        this.titleshow = false;
      } else {
        //判断是PC端/ 登录入口打开
        // console.log('pc')
        this.titleshow = true;
      }
    },
    leave() {
      this.titleshow = false;
    },
    qrCodeCreate() {
      var _this = this;
      document.getElementById("model-canvas").innerHTML = ""; // 每次加载，元素清空
      var canvas = document.getElementById("model-canvas");
      // 将属性拼接字符串即可
      var test = this.qrTexxt;
      QRCode.toCanvas(canvas, test, function(error) {
        if (error) console.error(error);
        //console.log("QRCode success!");
      });
    },
    qrCodeHandleClose() {
      //关闭弹窗
      this.QRCodeShow = false;
    },
    downLoad(row) {
      this.$axios
        .get("http://internal.pisx.com:8012/api/filedownload", {
          params: {
            filename: row
          },
          responseType: "blob"
        })
        .then(({ data }) => {
          const blob = new Blob([data]);
          var a = document.createElement("a"); //创建一个<a></a>标签
          a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
          a.download = row; //设置文件名
          a.style.display = "none"; // 障眼法藏起来a标签
          document.body.appendChild(a); // 将a标签追加到文档对象中
          a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
          a.remove(); // 一次性的，用完就删除a标签
        });
    },
    open() {
      // 打开弹窗
      this.QRCodeShow = true;
    },
  }
};
</script>

<style scoped lang="less">
.design {
  margin-top: 66px;
  .design_info {
    position: relative;
    font-size: 0;
  }
}

.tab-box {
  width: 100%;
  background-color: #f0f7fa;
  padding: 20px 0;
  .el-tabs ::v-deep .el-tabs__content {
    padding: 0 !important;
  }

  ::v-deep .el-tabs__item {
    font-size: 20px !important;
    font-weight: normal !important;
  }

  .el-tabs {
    width: 80%;
    margin: 0 auto;
    .design-layout {
      display: flex;
      .left {
        display: flex;
        flex-direction: column;
        padding: 20px 0;
        margin-left: 20px;
        .el-button {
          margin: 0;
          padding: 12px 20px;
        }
        .el-button.active {
          background-color: #409eff;
          color: #fff;
        }
      }

      .right {
        background-color: #fff;
        .image {
          display: inline-flex;
          flex-wrap: wrap;
          margin-right: -80px;
          padding: 0 0 20px 20px;
          .img-item {
            width: calc(25% - 40px);
            cursor: pointer;
            margin: 20px 20px 0 0;
          }
          .img-item__last {
            margin: 20px 0 0 0;
          }
          .img-item:hover {
            box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
          }
        }
      }

      .down-box {
        width: 100%;
        margin: 20px;
        .filename-wrapper {
          display: flex;
          align-items: center;
        }
        .down-img {
          width: 20px;
          height: 20px;
        }

        .file-name {
          margin-left: 10px;
        }
      }
    }
    .case-content {
      .case-img {
        display: inline-flex;
        flex-wrap: wrap;
        margin-right: -20px;
        padding: 0 0 0 20px;

        .case-box {
          display: flex;
          flex-direction: column;
          .case-img__item {
            cursor: pointer;
            margin: 20px 20px 0 0;
            width: 356px;
            height: 267px;
            min-height: 267px;
            max-height: 267px;
            max-width: 356px;
            min-width: 356px;
          }
          .case-img__last {
            margin: 20px 0 0 0;
          }
          .case-img__item {
            img:hover {
              box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
            }
          }
          .text {
            width: 356px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            color: #333;
            cursor: pointer;
          }
          .text:hover {
            color: #409eff;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.message-box {
  position: fixed;
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 16px;
  border-radius: 4px;
  background-color: #fef0f0;
  border-color: #fde2e2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: #f56c6c;
}

.model-content {
  display: flex;
  .model {
    font-size: 22px;
    color: #0047FF;
  }
  .name {
    margin-left: 10px;
    font-size: 18px;
  }
}
.design-service {
  padding: 20px;
  .service-title {
    font-size: 30px;
  }
  .service-box {
    display: flex;
    align-items: center;
    margin: 20px 0;
    margin-left: 200px;
    span {
      font-size: 20px;
      margin-left: 20px;
    }
    .el-button {
      width: 160px;
    }
  }
}

.design-contact {
  display: flex;
  flex-direction: column;
  padding: 20px;
  .contact-title {
    font-size: 30px;
  }
  .contact-box {
    display: flex;
    justify-content: center;
    .contact-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 332px;
      .left_info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span {
          font-size: 20px;
          padding-right: 10px;
          text-align: center;
        }
        img {
          margin-top: 40px;
        }
      }
    }
    .contact-right {
      margin-left: 30px;
    }
  }
}
</style>
